
import { defineComponent, PropType } from 'vue';
import useDialogVisible from '@/hooks/use-dialog-visible';
import type {
  IBackendOpsApplyProcessRes,
} from '@/api/project-service/type.d';
import {
  APPROVAL_PROCESS_TYPE_ENUM,
  APPROVAL_PROCESS_TYPE_LIST,
} from '@/constant/project-service';

export default defineComponent({
  name: 'OperationalApprovalProcess',
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    operationDataList: {
      type: Array as PropType<IBackendOpsApplyProcessRes[]>,
    },
  },
  setup(props, { emit }) {
    const { visible } = useDialogVisible(props, emit);
    console.log(props.operationDataList, 'operationDataList');

    return {
      visible,
      APPROVAL_PROCESS_TYPE_ENUM,
      APPROVAL_PROCESS_TYPE_LIST,
    };
  },
});
